export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

export const POSITION_CATEGORY_REQUEST = "POSITION_CATEGORY_REQUEST";
export const POSITION_CATEGORY_SUCCESS = "POSITION_CATEGORY_SUCCESS";
export const POSITION_CATEGORY_FAILURE = "POSITION_CATEGORY_FAILURE";

export const MOVE_CATEGORY_TO_TOP_REQUEST = "MOVE_CATEGORY_TO_TOP_REQUEST";
export const MOVE_CATEGORY_TO_TOP_SUCCESS = "MOVE_CATEGORY_TO_TOP_SUCCESS";
export const MOVE_CATEGORY_TO_TOP_FAILURE = "MOVE_CATEGORY_TO_TOP_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/categories/types.js